import API from "core/api/axios/base";
import ChangeNumberErrorHandler from "../handler/ChangeNumberErrorHandler";
import GenericErrorHandler from "../handler/GenericErrorHandler";

export default function LoginNumbersApi(token) {
  let config = {
    headers: {
      "content-type": "application/json",
      "x-client-key": process.env.REACT_APP_CLIENT_KEY,
      Authorization: "Bearer " + token,
      "x-accesstoken": token,
    },
    withCredentials: true,
  };

    config.headers["x-credentials-key"] =
      process.env.REACT_APP_X_CREDENTIALS_KEY;
  
  return API.get(`${process.env.REACT_APP_LOGIN_NUMBERS}`, config)
    .then((response) => {
      const { data } = response;
      // data.loginNumbers = [{id:"xxx", msisdn:"11985826159"}]
      // data.loginNumbers = []
      return data;
    })
    .catch((error) => {
      const errorHandler = GenericErrorHandler(error);
      const responseError = {
        ...errorHandler,
      };
      return responseError;
    });
}

export function SendToken(data, token) {
  let config = {
    headers: {
      "content-type": "application/json",
      "x-client-key": process.env.REACT_APP_CLIENT_KEY,
      "x-accesstoken": token,
    },
    withCredentials: true,
  };
 
    config.headers["x-credentials-key"] =
      process.env.REACT_APP_X_CREDENTIALS_KEY;

  return API.post(`${process.env.REACT_APP_LOGIN_NUMBERS}`, data, config)
    .then(({ data: { data } }) => {
      return data;
    })
    .catch((error) => {
      const errorHandler = GenericErrorHandler(error);
      const responseError = {
        ...errorHandler,
      };
      return responseError;
    });
}
export function updateSendToken(data, token) {
  let config = {
    headers: {
      "content-type": "application/json",
      "x-client-key": process.env.REACT_APP_CLIENT_KEY,
      "x-accesstoken": token,
    },
    withCredentials: true,
  };

    config.headers["x-credentials-key"] =
      process.env.REACT_APP_X_CREDENTIALS_KEY;

  return API.put(`${process.env.REACT_APP_LOGIN_NUMBERS}`, data, config)
    .then(({ data: { data } }) => {
      return data;
    })
    .catch((error) => {
      const errorHandler = ChangeNumberErrorHandler(error);
      const responseError = {
        ...errorHandler,
      };
      return responseError;
    });
}

export function deleteMsisdn(data, token) {
  let config = {
    headers: {
      "content-type": "application/json",
      "x-client-key": process.env.REACT_APP_CLIENT_KEY,
      "x-accesstoken": token,
    },
    withCredentials: true,
    data
  };
  
    config.headers["x-credentials-key"] =
      process.env.REACT_APP_X_CREDENTIALS_KEY;
  
  return API.delete(`${process.env.REACT_APP_LOGIN_NUMBERS}`, config)
    .then(({ data: {data} }) => {
      return data;
    })
    .catch((error) => {
      const errorHandler = GenericErrorHandler(error);
      const responseError = {
        ...errorHandler,
      };
      return responseError;
    });
}

export function ValidateToken(data, token) {
  let config = {
    headers: {
      "content-type": "application/json",
      "x-client-key": process.env.REACT_APP_CLIENT_KEY,
      "x-accesstoken": token,
    },
    withCredentials: true,
  };
 
    config.headers["x-credentials-key"] =
      process.env.REACT_APP_X_CREDENTIALS_KEY;
  
  return API.post(`${process.env.REACT_APP_LOGIN_NUMBERS}/valid`, data, config)
    .then(({ data }) => {
      return data;
    })
    .catch((error) => {
      const errorHandler = GenericErrorHandler(error);
      const responseError = {
        ...errorHandler,
      };
      return responseError;
    });
}

export function ReSendToken(data, token) {
  let config = {
    headers: {
      "content-type": "application/json",
      "x-client-key": process.env.REACT_APP_CLIENT_KEY,
      "x-accesstoken": token,
    },
    withCredentials: true,
  };

    config.headers["x-credentials-key"] =
      process.env.REACT_APP_X_CREDENTIALS_KEY;
  
  return API.post(`${process.env.REACT_APP_LOGIN_NUMBERS}/resend`, data, config)
    .then(({ data }) => {
      return data.data;
    })
    .catch((error) => {
      const errorHandler = GenericErrorHandler(error);
      const responseError = {
        ...errorHandler,
      };
      return responseError;
    });
}
